export const OPEN_COMPARE_PANEL_TRANSACTION = 'COMPARISON.OPEN_COMPARE_PANEL_TRANSACTION';
export const CLOSE_COMPARE_MODAL_ACTION = 'COMPARISON.CLOSE_COMPARE_MODAL_ACTION';
export const ON_ACTION_SELECT_FILE_MODAL_TRANSACTION =
	'COMPARISON.ON_ACTION_SELECT_FILE_TRANSACTION';
export const COMPARISON_MODEL_DATA_UPDATE_STORE_ACTION =
	'COMPARISON.COMPARISON_MODEL_DATA_UPDATE_STORE_ACTION';
export const COMPARISON_MODEL_DATA_ADD_STORE_ACTION =
	'COMPARISON.COMPARISON_MODEL_DATA_ADD_STORE_ACTION';
export const ON_VERSION_SELECT_TRANSACTION = 'COMPARISON.ON_VERSION_SELECT_TRANSACTION';
